var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecklistIssuesSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_107",
    "data-name": "Raggruppa 107",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.124,
    height: 16.924,
    viewBox: "0 0 14.124 16.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_152",
    "data-name": "Tracciato 152",
    d: "M27.525,8.437a1,1,0,0,0-1.009,1.009v6.248a.379.379,0,0,1-.4.4.385.385,0,0,1-.409-.4V10.249a1,1,0,1,0-2.009,0v5.444a.385.385,0,0,1-.409.4.379.379,0,0,1-.4-.4V12.668a1,1,0,1,0-2.01,0v9.47A3.231,3.231,0,0,0,24.1,25.361h4.516a2.735,2.735,0,0,0,1.951-.826l.022.022,3.99-4.07A1.4,1.4,0,1,0,32.6,18.514l-1.249,1.25V10.651a1.008,1.008,0,0,0-2.017,0v5.042a.4.4,0,0,1-.8,0V9.446A1,1,0,0,0,27.525,8.437Zm-2.667,9.47,1.637,1.637,1.63-1.637.994,1-1.63,1.629,1.644,1.644-1,.994-1.637-1.637L24.85,23.183l-1-1,1.644-1.644L23.856,18.9Z",
    transform: "translate(-20.875 -8.437)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistIssuesSmall);
export default __webpack_public_path__ + "static/media/ChecklistIssuesSmall.8dc1a2cf28e9d66b6dfacbb9df1f3872.svg";
export { ForwardRef as ReactComponent };